<template>
  <div>
    <b-form class="mb-3">
      <b-form-group label="Szűrés kampányok alapján" label-size="lg">
        <b-form-group label-cols="3" label="Fiók" label-for="accountId">
          <b-form-select
            id="accountId"
            v-model="accountId"
            :options="accounts"
          />
        </b-form-group>
        <b-form-group label-cols="3" label="Kezdő dátum" label-for="fromDate">
          <b-input-group>
            <b-form-datepicker
              id="fromDate"
              v-model="fromDate"
              v-bind="datePickerLabels"
              locale="hu-HU"
              required
            />
            <b-input-group-append>
              <b-button @click="fromDate = ''" variant="danger" size="sm"><i class="fas fa-trash"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label-cols="3" label="Záró dátum" label-for="toDate">
          <b-input-group>
            <b-form-datepicker
              id="toDate"
              v-model="toDate"
              v-bind="datePickerLabels"
              locale="hu-HU"
              required
            />
            <b-input-group-append>
              <b-button @click="toDate = ''" variant="danger" size="sm"><i class="fas fa-trash"></i></b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-button variant="info" :disabled="loading" @click="loading = true">Betöltés</b-button>
      </b-form-group>
    </b-form>
    <test-campaigns-table
      :from-date="fromDate"
      :to-date="toDate"
      :account-id="accountId"
      :query.sync="loading"
      :actions="actions"
      :processing="exporting"
    ></test-campaigns-table>
  </div>
</template>
<style lang="scss">
</style>
<script>
import moment from 'moment'
import datePickerLabels from '../common/_datePickerLabels'
import TestCampaignsTable from '../testcampaign/TestCampaignsTable'

export default {
  components: {
    'test-campaigns-table': TestCampaignsTable,
  },
  data() {
    return {
      datePickerLabels,
      fromDate: '',
      toDate: '',
      accountId: -1,
      loading: false,
      exporting: false,
    }
  },
  computed: {
    accounts() {
      var accounts = _.map(this.$store.state.accounts, account => ({
        value: account.id,
        text: account.name
      }))

      accounts.splice(0, 0, {
        value: -1,
        text: '- bármelyik -'
      })

      return accounts
    },
    actions() {
      return [{
        value: 'export',
        text: 'Exportálás',
        variant: 'success',
        confirmation: false,
        callback: (selected) => this.doExport(selected)
      }]
    }
  },
  methods: {
    doExport(selected) {
      this.exporting = true

      this.$http.request({
        url: this.$url('api.exports.do.tests'),
        method: 'POST',
        responseType: 'blob',
        data: {
          'test-campaigns': selected
        }
      })
        .then((response) => this.downloadFile(response))
        .finally(() => this.exporting = false)
    },
    downloadFile(response) {
      const suggestedFileName = this.getFilename(response.headers)

      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')

      link.href = url
      link.setAttribute('download', suggestedFileName); //or any other extension
      document.body.appendChild(link)
      link.click()
    },
    getFilename(headers) {
      var contentDisposition = headers['content-disposition']
      if(typeof contentDisposition === 'undefined') {
        return 'test.csv'
      }

      var parts = contentDisposition.split('filename=')
      if(parts.length > 1) {
        return parts[1]
      } else {
        return 'test.csv'
      }
    },
    load() {
      this.loading = true
      this.query = true
    }
  }
}
</script>